import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from './../ui/card';
import { Badge } from './../ui/badge';
import { Button } from './../ui/button';
import { Pencil, Trash2, Users } from 'lucide-react';
import { motion } from 'framer-motion';

const teamColors = {
  blue: 'from-blue-500 to-cyan-500',
  purple: 'from-purple-500 to-pink-500',
  green: 'from-emerald-500 to-teal-500',
  orange: 'from-orange-500 to-amber-500',
  red: 'from-red-500 to-rose-500',
  indigo: 'from-indigo-500 to-blue-500'
};

export default function TeamCard({ team, members, onEdit, onDelete }) {
  const teamMembers = members.filter(m => team.members?.includes(m.id));
  const colorGradient = teamColors[team.color] || teamColors.blue;

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -20 }}
    >
      <Card className="bg-white/80 backdrop-blur-sm hover:shadow-xl transition-all duration-300 border-2 hover:border-purple-300">
        <CardHeader className="pb-3">
          <div className="flex items-start justify-between gap-3">
            <div className="flex items-center gap-3 flex-1">
              <div className={`w-12 h-12 rounded-xl bg-gradient-to-br ${colorGradient} flex items-center justify-center shadow-lg`}>
                <Users className="w-6 h-6 text-white" />
              </div>
              <div className="flex-1 min-w-0">
                <CardTitle className="text-lg truncate">{team.name}</CardTitle>
                {team.description && (
                  <p className="text-xs text-slate-500 line-clamp-1 mt-1">{team.description}</p>
                )}
              </div>
            </div>
            <Badge className={team.active ? 'bg-emerald-100 text-emerald-700' : 'bg-slate-100 text-slate-600'}>
              {team.active ? 'Ativa' : 'Inativa'}
            </Badge>
          </div>
        </CardHeader>

        <CardContent className="space-y-3">
          {/* Members */}
          <div>
            <p className="text-xs font-medium text-slate-500 mb-2">
              Membros ({teamMembers.length})
            </p>
            {teamMembers.length > 0 ? (
              <div className="flex flex-wrap gap-2">
                {teamMembers.slice(0, 5).map((member) => (
                  <Badge key={member.id} variant="secondary" className="text-xs">
                    {member.name}
                  </Badge>
                ))}
                {teamMembers.length > 5 && (
                  <Badge variant="secondary" className="text-xs bg-slate-100 text-slate-600">
                    +{teamMembers.length - 5}
                  </Badge>
                )}
              </div>
            ) : (
              <p className="text-xs text-slate-400">Nenhum membro</p>
            )}
          </div>

          {/* Actions */}
          <div className="flex items-center gap-2 pt-2 border-t">
            <Button
              variant="outline"
              size="sm"
              onClick={() => onEdit(team)}
              className="flex-1 hover:bg-purple-50 hover:border-purple-300"
            >
              <Pencil className="w-3.5 h-3.5 mr-1" />
              Editar
            </Button>
            <Button
              variant="outline"
              size="sm"
              onClick={() => onDelete(team)}
              className="flex-1 hover:bg-red-50 hover:border-red-300 text-red-600"
            >
              <Trash2 className="w-3.5 h-3.5 mr-1" />
              Excluir
            </Button>
          </div>
        </CardContent>
      </Card>
    </motion.div>
  );
}